import React from "react";
import { cn } from "@/lib/utils";
import { dashboardStyles } from "./dashboard-styles";

type StatTileProps = {
  label: string;
  value: React.ReactNode;
  hint?: string;
  valueClassName?: string;
  className?: string;
};

export function StatTile({
  label,
  value,
  hint,
  valueClassName,
  className,
}: StatTileProps) {
  return (
    <div className={cn(dashboardStyles.statTile, className)}>
      <p className={dashboardStyles.statTileLabel}>{label}</p>
      <p className={cn(dashboardStyles.statTileValue, valueClassName)}>{value}</p>
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
